import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

const ProtectedRoutes = () => {
    const { isAuth } = useSelector((state: RootState) => state.authUser);
    
    return (
        <>
            {
                isAuth ? <Outlet /> : <Navigate to="/login"/>
            }
        </>
    );
}

export default ProtectedRoutes;